module.exports = __webpack_public_path__ + "static/img/t9_lobby.a766b72.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/t9_lobby.png
// module id = 5G+0
// module chunks = 1